import gsap, { Power2 } from 'gsap';
import { Basics, isSmartphone } from '../_app/cuchillo/core/Basics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { DataHolder } from '../DataHolder';
import Header from '../layout/Header';
import DefaultNoScroll from './DefaultNoScroll';
import Default from './Default';
import { GetBy } from '../_app/cuchillo/core/Element';
import Wrap from '../layout/Wrap';

export default class About extends Default {
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
    Basics.oldPage = "about";
   
    this._items = [];
    [...GetBy.selector(".block-wysiwyg > *", this.container)].map(dom => { this._items.push(dom); });
    for (let i = 0; i < this._items.length; i++) {
      gsap.set(this._items[i],{opacity:0});
    }
    
    if(isSmartphone) Header.mode = "BLUR";
    else Header.mode = "INVERT";
  }

  beforeShow() {
    super.beforeShow();
    Header.title.hide();
  }

  show__effect() {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Header.show(5);
        //Preloader.hide(() => {});
        this.afterShow()
      });
    } else {
      Wrap.show(() => {},{duration:.1, delay:.1});
      this.afterShow()
    }

    let delay = .2;
    for (let i = 0; i < this._items.length; i++) { 
      gsap.to(this._items[i],{opacity:1, ease:Power2.easeOut, duration:.3, delay:delay + .1 * i});
    }    
  }

  afterHide() {
    super.afterHide();
  }
}

ControllerPage._addPage("about", About)
